export default "__VITE_ASSET__BBbO6yM4__"